import { ControlButton } from '@xyflow/react'

export default function FullSizeBtn({ onClick }) {
    return (
        <ControlButton title='fullscreen' onClick={onClick}>
            F
        </ControlButton>
    )
}